enum ContractSigningTypes {
  Manually = 'Manually',
  DocuSign = 'DocuSign',
  Any = 'Any',
}

export { ContractSigningTypes };
export type VerifyContractSigningTypes = Utils.VerifyExtends<
  Model.Enum.ContractSigningTypes,
  Utils.ValueOf<typeof ContractSigningTypes>
>;
